export enum ImageRatio {
    SixteenByNine = 1.778,
    TwentyFourByFive = 4.8,
    Square = 1,
    TwoByOne = 2,
}

export enum ImageMimeType {
    JPEG = 'image/jpeg',
    PNG = 'image/png',
    GIF = 'image/gif',
    WebP = 'image/webp',
}

export enum ImageType {
    JPEG = 'JPEG',
    PNG = 'PNG',
    GIF = 'GIF',
    WebP = 'WebP',
}
